import * as actionTypes from '../action-types'

const initialState = {
  headerPanes: [],
  headerPaneKey: ''
};

export default function app(state = initialState, action = {}) {
  console.log(state)
  console.log(action)
  switch (action.type) {
    case actionTypes.HEADER_PANES:
      let headerPaneKey = ''
      if (action.list && action.list.length > 0) {
        headerPaneKey = action.list[0].key
      }
      return Object.assign({}, state, {
        headerPanes: action.list || [],
        headerPaneKey
      });
    case actionTypes.HEADER_CUR_PANE:
      console.log(Object.assign({}, state, {
        headerPaneKey: action.key || ''
      }))
      return Object.assign({}, state, {
        headerPaneKey: action.key || ''
      });
    case actionTypes.Msg_One_Key:
      return Object.assign({}, state, {
        MsgOneKey: action.flag || false
      });
    default:
      return state
  }
}